import { useQueryClient } from "@tanstack/react-query";
import { useAppMutation } from "../../../../../../../../http/useAppMutation.ts";
import { trackEvent } from "../../../../../../../../tracking/tracking.ts";
import { useWorkspaceUuid } from "../../../../../../../hooks/useWorkspaceUuid.ts";
import { useBoardUuid } from "../../../../../../hooks/useBoardUuid.ts";
import { useEditImageWithPromptSettings } from "./useEditImageWithPromptSettings.ts";

export const useEditImageWithPrompt = ({
  onSuccess,
}: {
  onSuccess?: () => void;
}) => {
  const workspaceUuid = useWorkspaceUuid();
  const boardUuid = useBoardUuid();
  const { settings } = useEditImageWithPromptSettings(boardUuid);

  const editImageWithPromptMutation = useAppMutation({
    path: "boards/edit-image-with-prompt",
    invalidate: [
      `workspaces/${workspaceUuid}/boards`,
      `boards/${boardUuid}/assets`,
    ],
    onSuccess: () => {
      trackEvent(
        "content:generate",
        {
          generation_type: "EditWithPrompt",
        },
        true,
      );
    },
  }).mutation;

  const queryClient = useQueryClient();
  return {
    mutation: ({ assetUuid }: { assetUuid: string }) => {
      editImageWithPromptMutation.mutate(
        {
          board_uuid: boardUuid,
          asset_uuid: assetUuid,
          prompt: settings.prompt,
          num_generations: settings.num_generations,
        },
        {
          onSuccess: () => {
            [`assets/${assetUuid}`, `assets/${assetUuid}/history`].map(
              (queryKey) =>
                void queryClient.invalidateQueries({ queryKey: [queryKey] }),
            );
            onSuccess?.();
          },
        },
      );
    },
    isLoading: editImageWithPromptMutation.isLoading,
  };
};
